import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "How much does a house move cost in Cardiff?", a: "A typical 2-bed Cardiff move costs £180–£420 depending on distance, floor level and packing needs. Message us on WhatsApp for a fixed, no-obligation quote — usually within 15 minutes." },
  { q: "Do you provide packing materials?", a: "Yes — we supply premium double-wall boxes, tape, wrap and fragile-item protection, and offer full professional packing services with our packers & movers package." },
  { q: "Can you move offices?", a: "Yes. We handle office relocations of all sizes across Cardiff, Newport and Swansea with minimum downtime, out-of-hours slots and secure IT-equipment transport." },
  { q: "Do you provide deep cleaning and end of tenancy cleaning near me?", a: "If you're in Cardiff, Newport, Swansea or anywhere in South Wales — yes. Our deep clean and end-of-tenancy clean follows the standard letting-agent checklist and comes with a 48-hour re-clean guarantee." },
  { q: "Are you insured?", a: "Yes, BoxB Solutions is fully insured with Goods in Transit and Public Liability cover — certificates available on request." },
  { q: "Are you the best packers and movers or man and van service near me?", a: "We're rated 4.9/5 by 127+ Cardiff and South Wales customers for our man & van, packers & movers, house removals and cleaning services. Same-day availability across Cardiff, Newport and Swansea." },
  { q: "Can I book via WhatsApp?", a: "Absolutely. Message us on WhatsApp at +44 7570 291363 with your dates and postcode, and we'll confirm your booking quickly — with a fixed price." },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="py-20 md:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-4">
        <span className="text-xs tracking-[0.22em] uppercase font-bold text-[#2563EB]">FAQ</span>
        <h2 className="mt-4 font-display font-semibold text-[#0A192F] text-4xl sm:text-5xl tracking-tight">
          Answers, before you ask.
        </h2>
        <p className="mt-5 text-slate-600 leading-relaxed">
          Still curious? Message us on WhatsApp — we usually reply within minutes.
        </p>
      </div>

      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display font-medium text-lg sm:text-xl text-[#0A192F] py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-slate-600 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
